import { CategoriesFilter } from '../get-data/transform/category-filter';

export const UPDATE_CATEGORIES_FILTER = 'UPDATE_CATEGORIES_FILTER';

export const updateCategoriesFilter = (payload: CategoriesFilter) => ({
    type: UPDATE_CATEGORIES_FILTER,
    payload,
});

export default (
    state = {
        selectedCategorySeoDisplayName: '',
        ancestorCategories: [],
        descendentCategories: [],
    } as CategoriesFilter,
    action: ReturnType<typeof updateCategoriesFilter>
) => (action.type === UPDATE_CATEGORIES_FILTER ? { ...state, ...action.payload } : state);
